// Przelicza rozmiar milimetrów na px

export const getSizeFromMm = (mm) => {
  return Math.ceil((mm / 4) / 5) * 5
}

export const getSizeFromPx = (px) => {
  return Math.floor((px * 4))
}